/**
 * Tour Styles - Navy Glassmorphism Theme
 * Matches SearchableSelect.tsx styling with transparent navy background,
 * backdrop blur, white text, and orange accents
 */
import { Styles } from "react-joyride";

export const tourStyles: Partial<Styles> = {
  options: {
    // Orange primary color for highlights and buttons
    primaryColor: "oklch(0.7309 0.1839 51.23)", // Orange-500
    // Navy glassmorphism background
    backgroundColor: "rgba(15, 23, 42, 0.6)", // #0F172A with 60% opacity
    // White text
    textColor: "oklch(1 0 0)", // White
    // Dark overlay behind tooltip
    overlayColor: "rgba(0, 0, 0, 0.5)",
    // Beacon size for attention markers
    beaconSize: 36,
    // High z-index to appear above all content
    zIndex: 10000,
  },
  tooltip: {
    // Apple-style glassmorphism with enhanced blur
    backgroundColor: "rgba(30, 30, 46, 0.88)",
    backdropFilter: "blur(20px) saturate(160%) brightness(1.05)",
    WebkitBackdropFilter: "blur(20px) saturate(160%) brightness(1.05)",
    // Glowing purple border effect
    border: "1px solid rgba(147, 51, 234, 0.6)",
    borderRadius: "0.75rem",
    color: "oklch(1 0 0)", // White text
    fontSize: "0.875rem", // 14px
    padding: "1.25rem",
    // Glowing border shadow with deep purple gradient
    boxShadow:
      "0 0 0 1px rgba(147, 51, 234, 0.4), 0 0 20px rgba(147, 51, 234, 0.5), 0 0 40px rgba(126, 34, 206, 0.3), 0 10px 30px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.1)",
  },
  tooltipContainer: {
    textAlign: "left",
  },
  tooltipTitle: {
    color: "oklch(0.7309 0.1839 51.23)", // Orange accent
    fontSize: "1rem", // 16px
    fontWeight: "600",
    marginBottom: "0.5rem",
  },
  tooltipContent: {
    color: "rgba(255, 255, 255, 0.9)",
    fontSize: "0.875rem",
    lineHeight: "1.5",
    padding: "0.5rem 0",
  },
  buttonNext: {
    backgroundColor: "oklch(0.7309 0.1839 51.23)", // Orange
    borderRadius: "0.625rem",
    color: "oklch(1 0 0)", // White text
    fontSize: "0.875rem",
    fontWeight: "500",
    padding: "0.5rem 1rem",
    border: "none",
    cursor: "pointer",
    transition: "all 0.2s",
  },
  buttonBack: {
    color: "rgba(255, 255, 255, 0.7)",
    marginRight: "0.5rem",
    fontSize: "0.875rem",
    fontWeight: "500",
    padding: "0.5rem 1rem",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    borderRadius: "0.625rem",
    backgroundColor: "transparent",
    cursor: "pointer",
    transition: "all 0.2s",
  },
  buttonSkip: {
    color: "rgba(255, 255, 255, 0.5)",
    fontSize: "0.875rem",
    fontWeight: "400",
    padding: "0.25rem 0.5rem",
    border: "none",
    backgroundColor: "transparent",
    cursor: "pointer",
  },
  buttonClose: {
    color: "rgba(255, 255, 255, 0.7)",
    fontSize: "1.25rem",
    padding: "0.25rem",
    border: "none",
    backgroundColor: "transparent",
    cursor: "pointer",
    position: "absolute",
    right: "0.5rem",
    top: "0.5rem",
  },
  beacon: {
    // Pulsing orange beacon to draw attention
    backgroundColor: "oklch(0.7309 0.1839 51.23)",
  },
  beaconInner: {
    backgroundColor: "oklch(0.7309 0.1839 51.23)",
  },
  beaconOuter: {
    backgroundColor: "rgba(255, 107, 53, 0.2)",
    border: "2px solid oklch(0.7309 0.1839 51.23)",
  },
  spotlight: {
    // Highlight the targeted element
    borderRadius: "0.375rem",
  },
};
